import * as React from 'react';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-utils-html';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../hooks/useCartDiscounts/types.js';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import { ProductDetailCTA } from '../../../components/CTAs/ProductDetailCTA/ProductDetailCTA.js';
import '@grandvisionhq/content';

const AccessoriesCTA = ()=>{
    const { activeVariant: { channelAvailability , sku  } ,  } = useProductData();
    const handleConversionEvent = React.useCallback(()=>{
    // @TODO: handle conversion event in #
    // Possibly we will need to add this to products-details-v2
    }, []);
    const onAddToCartSuccess = React.useCallback(()=>{
    // @TODO: in a future story, this is where the data analytics will be triggered
    }, []);
    const productAction = channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE';
    return /*#__PURE__*/ React.createElement(ProductDetailCTA, {
        action: productAction,
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku: sku,
            onSuccess: onAddToCartSuccess
        }
    });
};

export { AccessoriesCTA };
//# sourceMappingURL=AccessoriesCTA.js.map
